export default function <T extends Record<string, unknown>>(state: T = {} as T): T {
  return state;
}
